
/*


export const selectAuthenticatedUser = createSelector(
  (state: IAppState) => state.authenticatedUser,
  (state: IAuthenticatedUserState) => state.user
);

 */

import {createSelector} from "@ngrx/store";
import {IAppState} from "../../state/app.state";
import {ITasksListState} from "../../state/tasks/tasks.state";

export const selectTasksList = createSelector(
  (state: IAppState) => state.tasks.tasksList,
  (state:ITasksListState) => state
);
